import { render, staticRenderFns } from "./IdentificationLog.vue?vue&type=template&id=d528c8e8&scoped=true&"
import script from "./IdentificationLog.vue?vue&type=script&lang=js&"
export * from "./IdentificationLog.vue?vue&type=script&lang=js&"
import style0 from "./IdentificationLog.vue?vue&type=style&index=0&id=d528c8e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d528c8e8",
  null
  
)

export default component.exports